// extracted by mini-css-extract-plugin
module.exports = {"key":"Key__key__1wup0","keyCap":"Key__keyCap__3SDRp"};